module.exports = __webpack_public_path__ + "static/media/receipt.c3d7e6df.png";